import type { ProductRating } from "@/features/rating/types/product-rating.type";
import { GET } from "@/lib/methods";

export const getProductRating = async (
  productId: string,
): Promise<ProductRating | null> => {
  try {
    const response = await GET<ProductRating>({
      url: `/api/rating/${productId}`,
    });
    return response ?? null;
  } catch (error) {
    const status =
      typeof error === "object" && error && "status" in error
        ? (error as { status?: number }).status
        : undefined;
    // 404 means the diet has no reviews yet – treat as empty, not an error.
    if (status === 404) {
      return null;
    }
    throw error;
  }
};
